/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-13 14:33:34
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 17:13:12
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/BraftEditor/index.tsx
 */
// 引入编辑器组件
import BraftEditor from 'braft-editor';
import ColorPicker from 'braft-extensions/dist/color-picker';
const options = {
  //includeEditors: ['editor-id-1'], // 指定该模块对哪些BraftEditor生效，不传此属性则对所有BraftEditor有效
  //excludeEditors: ['editor-id-2'], // 指定该模块对哪些BraftEditor无效
  theme: 'light', // 指定取色器样式主题，支持dark和light两种样式
};
BraftEditor.use(ColorPicker(options));

// 引入编辑器样式
import 'braft-editor/dist/index.css';
import 'braft-extensions/dist/color-picker.css';

import { ContentUtils } from 'braft-utils';
import React from 'react';
import { Icon } from 'src/tools/icon';
import css from './css.module.less';
//import LinkLibrary from 'src/constrains/LinkLibrary';
import { getI18nFromGeneral } from '@/src/tools/tools';
import Modal from './LinkModal';
import { get } from 'lodash';
import { ETextCopyTrigger } from 'src/tools/contentModulesFieldName';
import emit from 'src/tools/event';
const font = [
  {
    name: 'Araial',
    family: 'Arial, Helvetica, sans-serif',
  },
  {
    name: 'Georgia',
    family: 'Georgia, serif',
  },
  {
    name: 'Impact',
    family: 'Impact, serif',
  },
  {
    name: 'Monospace',
    family: '"Courier New", Courier, monospace',
  },
  {
    name: 'Tahoma',
    family: 'tahoma, arial, "Hiragino Sans GB", 宋体, sans-serif',
  },
  {
    name: 'sans-serif',
    family: 'sans-serif, arial, "Hiragino Sans GB", 宋体',
  },
  {
    name: 'zt_neue_ralewe',
    family: 'zt_neue_ralewe, serif',
  },
];
class EditorDemo extends React.Component<any, any> {
  constructor(props) {
    super(props);
    const { data, onErrorChange } = props;
    const convertedData = BraftEditor.createEditorState(data, {
      fontFamilies: font,
    });
    if (onErrorChange) {
      onErrorChange(convertedData.isEmpty());
    }
    this.state = {
      editorState: convertedData,
      selectedText: '',
      visible: false,
    };

    this.handleEditorChange = this.handleEditorChange.bind(this);
    this.setData = this.setData.bind(this);
    this.triggerChangeValue = this.triggerChangeValue.bind(this);
  }

  setData(data) {
    const { onErrorChange } = this.props;
    const convertedData = BraftEditor.createEditorState(data);
    if (onErrorChange) {
      onErrorChange(convertedData.isEmpty());
    }
    this.setState({
      editorState: convertedData,
    });
  }

  // componentDidUpdate(
  //   prevProps: Readonly<any>,
  //   prevState: Readonly<any>,
  //   snapshot?: any,
  // ): void {
  //   if (prevProps.data !== this.props.data) {
  //     this.setData(this.props.data);
  //   }
  // }

  //   getList();
  // if (!noListener) emit.on(EnumAction.pageLanguageListReload, uuidGetList);
  // return () => {
  //   emit.removeListener(EnumAction.pageLanguageListReload, uuidGetList);
  // }; removeListener

  componentDidMount() {
    emit.on(ETextCopyTrigger, this.triggerChangeValue);
  }
  componentWillUnmount(): void {
    emit.removeListener(ETextCopyTrigger, this.triggerChangeValue);
  }

  submitContent = async () => {
    const htmlContent = this.state.editorState.toHTML();
    console.log(htmlContent);
  };

  triggerChangeValue = (b, d) => {
    const { eventProps } = this.props;
    const breakpoint = get(eventProps, 'breakpoint');
    if (b === breakpoint) {
      const convertedData = BraftEditor.createEditorState(d, {
        fontFamilies: font,
      });
      console.log('d', b, d);
      this.handleEditorChange(convertedData);
    }
  };

  handleEditorChange = (editorState) => {
    //const { editorState: _cS } = this.state;
    const { onChange, onErrorChange, data, onEmpty } = this.props;
    const selectedText = ContentUtils.getSelectionText(editorState);
    // const text = editorState.toHTML();
    //const _cText = _cS.toHTML();
    // const _cEmpty = _cS.isEmpty();
    const _covertedData = BraftEditor.createEditorState(data).toHTML();
    // const isEmpty = editorState.isEmpty();

    // console.log('_cText', _cText);
    // console.log('_cEmpty', _cEmpty);
    // console.log('text', text);
    //
    // console.log('coverteddata', BraftEditor.createEditorState(data).toHTML());

    // console.log('isEmpty', isEmpty);
    this.setState({ editorState, selectedText }, () => {
      const text = editorState.toHTML();
      const isEmpty = editorState.isEmpty();

      if (isEmpty && onEmpty) {
        return onEmpty({ data: '', isEmpty });
      }
      if (onChange && _covertedData !== text) {
        onChange({ data: text, isEmpty });
      }
      if (onErrorChange) {
        onErrorChange(isEmpty);
      }
    });

    //console.log(selectedText);
  };
  // insertHello = () => {
  //   this.setState({
  //     editorState: ContentUtils.insertText(this.state.editorState, '你好啊！'),
  //   });
  // };
  render() {
    const { editorState, selectedText } = this.state;
    const {
      err,
      help,
      id,
      configFront,
      configBack,
      linkSet,
      contentStyle,
      disabled,
      placeholder,
      salesChannelContentUuid,
      salesChannelUuid,
    } = this.props;
    const controls = [
      ...(configFront || [
        'undo',
        'redo',
        'separator',
        'line-height',
        'letter-spacing',
        'bold',
        'italic',
        'underline',
        'text-color',
        'separator',
        'font-family',
        'separator',
        'font-size',
        'separator',
        'list-ul',
        'list-ol',
        'text-align',
        'separator',
        'list-ul',
        'list-ol',
        'code',
        'separator',
      ]),
      {
        key: 'Link', // 控件唯一标识，必传
        type: 'button',
        title: getI18nFromGeneral('general.braftEditor.link'), // 指定鼠标悬停提示文案
        className: selectedText ? css.link : css.linkDisable, // 指定按钮的样式名
        // html: 'disabled', // 指定在按钮中渲染的html字符串
        text: (
          <Icon
            type='iconlink'
            className={selectedText ? css.link : css.linkDisable}
          />
        ), // 指定按钮文字，此处可传入jsx，若已指定html，则text不会显示
        onClick: () => {
          if (selectedText) {
            this.setState({ visible: true });
          }
        },
      },
      {
        key: 'RemoveLink', // 控件唯一标识，必传
        type: 'button',
        title: getI18nFromGeneral('general.braftEditor.removeLink'), // 指定鼠标悬停提示文案
        className: selectedText ? css.link : css.linkDisable, // 指定按钮的样式名
        // html: 'disabled', // 指定在按钮中渲染的html字符串
        text: (
          <Icon
            type='iconunlink'
            className={selectedText ? css.link : css.linkDisable}
          />
        ), // 指定按钮文字，此处可传入jsx，若已指定html，则text不会显示
        onClick: () => {
          // if (selectedText) {
          //   this.setState({ visible: true });
          // }
          this.setState({
            editorState: ContentUtils.toggleSelectionLink(
              this.state.editorState,
              false,
            ),
          });
        },
      },
      ...(configBack || []),
    ];

    // const colors = [
    //   '#00000000',
    //   '#000000',
    //   '#333333',
    //   '#666666',
    //   '#999999',
    //   '#cccccc',
    //   '#ffffff',
    //   '#61a951',
    //   '#16a085',
    //   '#07a9fe',
    //   '#003ba5',
    //   '#8e44ad',
    //   '#f32784',
    //   '#c0392b',
    //   '#d35400',
    //   '#f39c12',
    //   '#fdda00',
    //   '#7f8c8d',
    //   '#2c3e50',
    // ];

    const pastedTextHandler = (text, html, editorState, editor) => {
      if (html) {
        const imgReg = /<img.*?(?:>|\/>)/gi; //定义正则表达式（拿到img标签所有值）
        let htmlWithoutExternalImages = html;

        const deArray = html.match(imgReg); //使用正则表达式，拿到的是数组
        //["<img src="images/01.gif">", "<img src="images/02.gif">"]
        if (deArray != null && deArray != undefined) {
          for (const vm of deArray) {
            htmlWithoutExternalImages = htmlWithoutExternalImages.replace(
              vm,
              '*',
            ); //放在循环中剔除img标签
          }
        }

        // const htmlWithoutExternalImages = stripExternalImages(html);
        // // 将处理好的html内容插入到编辑器
        editor.setValue(
          ContentUtils.insertHTML(
            editorState,
            htmlWithoutExternalImages,
            'paste',
          ),
        );
        // return一个'handled'字符串来表示此次粘贴行为已经处理好了，否则编辑器会按它自己的逻辑去处理
        return 'handled';
      }
    };
    return (
      <React.Fragment>
        <div
          id={id}
          className={`my-component ${css.wrapper} ${
            disabled ? css.disabled : ''
          } ${err ? css.err : ''}`}>
          {true && (
            <Modal
              linkSet={linkSet}
              visible={this.state.visible}
              editorState={this.state.editorState}
              selectedText={this.state.selectedText}
              onCancel={() => {
                this.setState({ visible: false });
              }}
              onConfirm={(e) => {
                this.setState({ editorState: e, visible: false });
              }}
              onAfterClose={() => {
                this.setState({ selectedText: '' });
              }}
              salesChannelContentUuid={salesChannelContentUuid}
              salesChannelUuid={salesChannelUuid}
            />
          )}

          <BraftEditor
            placeholder={placeholder}
            language={(languages, context) => {
              if (context === 'braft-editor') {
                languages.en.controls.tempColors = getI18nFromGeneral(
                  'general.braftEditor.tempColors',
                );
                languages.en.controls.textColor = getI18nFromGeneral(
                  'general.braftEditor.textColor',
                );
                languages.en.controls.backgroundColor = getI18nFromGeneral(
                  'general.braftEditor.backgroundColor',
                );
                languages.en.controls.textIndent = getI18nFromGeneral(
                  'general.braftEditor.textIndent',
                );
                languages.en.controls.increaseIndent = getI18nFromGeneral(
                  'general.braftEditor.increaseIndent',
                );
                languages.en.controls.decreaseIndent = getI18nFromGeneral(
                  'general.braftEditor.decreaseIndent',
                );
                languages.en.controls.strikeThrough = getI18nFromGeneral(
                  'general.braftEditor.strikeThrough',
                );
                languages.en.controls.textAlign = getI18nFromGeneral(
                  'general.braftEditor.textAlign',
                );
                languages.en.controls.floatLeft = getI18nFromGeneral(
                  'general.braftEditor.floatLeft',
                );
                languages.en.controls.floatRight = getI18nFromGeneral(
                  'general.braftEditor.floatRight',
                );
                languages.en.controls.superScript = getI18nFromGeneral(
                  'general.braftEditor.superScript',
                );
                languages.en.controls.subScript = getI18nFromGeneral(
                  'general.braftEditor.subScript',
                );
                languages.en.controls.removeStyles = getI18nFromGeneral(
                  'general.braftEditor.removeStyles',
                );
                languages.en.controls.headings = getI18nFromGeneral(
                  'general.braftEditor.headings',
                );
                languages.en.controls.header = getI18nFromGeneral(
                  'general.braftEditor.header',
                );
                languages.en.controls.normal = getI18nFromGeneral(
                  'general.braftEditor.normal',
                );
                languages.en.controls.blockQuote = getI18nFromGeneral(
                  'general.braftEditor.blockQuote',
                );
                languages.en.controls.link = getI18nFromGeneral(
                  'general.braftEditor.link',
                );
                languages.en.controls.unlink = getI18nFromGeneral(
                  'general.braftEditor.unlink',
                );
                languages.en.controls.hr = getI18nFromGeneral(
                  'general.braftEditor.hr',
                );
                languages.en.controls.media = getI18nFromGeneral(
                  'general.braftEditor.media',
                );
                languages.en.controls.mediaLibirary = getI18nFromGeneral(
                  'general.braftEditor.mediaLibirary',
                );
                languages.en.controls.emoji = getI18nFromGeneral(
                  'general.braftEditor.emoji',
                );
                languages.en.controls.fullscreen = getI18nFromGeneral(
                  'general.braftEditor.fullscreen',
                );
                languages.en.controls.exitFullscreen = getI18nFromGeneral(
                  'general.braftEditor.exitFullscreen',
                );

                languages.en.controls.clear = getI18nFromGeneral(
                  'general.commonStoreProductsWithTable.clear',
                );
                languages.en.controls.undo = getI18nFromGeneral(
                  'general.upload.EditModal.undo',
                );
                languages.en.controls.redo = getI18nFromGeneral(
                  'general.upload.EditModal.redo',
                );
                languages.en.controls.bold = getI18nFromGeneral(
                  'general.braftEditor.bold',
                );
                languages.en.controls.italic = getI18nFromGeneral(
                  'general.braftEditor.italic',
                );
                languages.en.controls.underline = getI18nFromGeneral(
                  'general.braftEditor.underline',
                );
                languages.en.controls.color = getI18nFromGeneral(
                  'general.braftEditor.color',
                );
                languages.en.controls.unorderedList = getI18nFromGeneral(
                  'general.braftEditor.unorderedList',
                );
                languages.en.controls.orderedList = getI18nFromGeneral(
                  'general.braftEditor.orderedList',
                );
                languages.en.controls.alignLeft = getI18nFromGeneral(
                  'general.braftEditor.alignLeft',
                );
                languages.en.controls.alignCenter = getI18nFromGeneral(
                  'general.braftEditor.alignCenter',
                );
                languages.en.controls.alignRight = getI18nFromGeneral(
                  'general.braftEditor.alignRight',
                );
                languages.en.controls.alignJustify = getI18nFromGeneral(
                  'general.braftEditor.alignJustify',
                );
                languages.en.controls.code = getI18nFromGeneral(
                  'general.braftEditor.code',
                );
                languages.en.controls.lineHeight = getI18nFromGeneral(
                  'general.braftEditor.lineHeight',
                );
                languages.en.controls.letterSpacing = getI18nFromGeneral(
                  'general.braftEditor.letterSpacing',
                );
                languages.en.controls.fontFamily = getI18nFromGeneral(
                  'general.braftEditor.fontFamily',
                );
                languages.en.controls.fontSize = getI18nFromGeneral(
                  'general.braftEditor.fontSize',
                );

                return languages.en;
              }
            }}
            readOnly={disabled}
            fontFamilies={font}
            value={editorState}
            onChange={this.handleEditorChange}
            onSave={this.submitContent}
            controls={controls}
            contentStyle={contentStyle}
            textBackgroundColor={false}
            handlePastedText={pastedTextHandler}
          />
        </div>
        {err && (
          <div className={css.help}>
            {help || getI18nFromGeneral('general.error.thisitemcannotbeempty')}
          </div>
        )}
      </React.Fragment>
    );
  }
}
export default EditorDemo;
